<section class="w-full h-auto pt-[4em] pb-[2em] main-wrapper">
    <div class="w-full appointment-wrapper">
        <div class="mb-[3em] mx-[1em] relative appointment-container">
            <div class="flex justify-between h-[100%]">
                <div class="md:flex">
                    <div class="booking-left">
                        <h2 class="text-left">Name</h2>
                        <h4>Total Members : <span>3</span></h4>
                    </div>
                    <div class="booking-center">
                        <p>
                            Time :
                            <span>9:30 - 10:30</span>
                        </p>
                        <p>
                            Date :
                            <span>3 February, 2023</span>
                        </p>
                    </div>
                </div>
            </div>
            <a href="" class="flex items-center bg-green custom-icon">
                <mat-icon class="custom-icon-style">edit </mat-icon>
                <span>Edit</span>
            </a>
            <a href="" class="flex items-center custom-del-icon">
                <mat-icon class="custom-icon-style">delete_forever</mat-icon>
                <span>Delete</span>
            </a>
        </div>
        <div class="w-3/4 mb-[2em] mx-[1em] relative appointment-container bg-">
            <div class="flex justify-between h-[100%]">
                <div class="md:flex">
                    <div class="booking-left">
                        <h2 class="text-left">Name</h2>
                        <h4>Total Members : <span>3</span></h4>
                    </div>
                    <div class="booking-center">
                        <p>
                            Time :
                            <span>9:30 - 10:30</span>
                        </p>
                        <p>
                            Date :
                            <span>3 February, 2023</span>
                        </p>
                    </div>
                </div>
            </div>
            <a href="" class="flex items-center bg-green custom-icon">
                <mat-icon class="custom-icon-style">edit </mat-icon>
                <span>Edit</span>
            </a>
            <a href="" class="flex items-center custom-del-icon">
                <mat-icon class="custom-icon-style">delete_forever</mat-icon>
                <span>Delete</span>
            </a>
        </div>
        <div class="w-3/4 mb-[2em] mx-[1em] relative appointment-container bg-">
            <div class="flex justify-between h-[100%]">
                <div class="md:flex">
                    <div class="booking-left">
                        <h2 class="text-left">Name</h2>
                        <h4>Total Members : <span>3</span></h4>
                    </div>
                    <div class="booking-center">
                        <p>
                            Time :
                            <span>9:30 - 10:30</span>
                        </p>
                        <p>
                            Date :
                            <span>3 February, 2023</span>
                        </p>
                    </div>
                </div>
            </div>
            <a href="" class="flex items-center bg-green custom-icon">
                <mat-icon class="custom-icon-style">edit </mat-icon>
                <span>Edit</span>
            </a>
            <a href="" class="flex items-center custom-del-icon">
                <mat-icon class="custom-icon-style">delete_forever</mat-icon>
                <span>Delete</span>
            </a>
        </div>
        <div class="w-3/4 mb-[2em] mx-[1em] relative appointment-container bg-">
            <div class="flex justify-between h-[100%]">
                <div class="md:flex">
                    <div class="booking-left">
                        <h2 class="text-left">Name</h2>
                        <h4>Total Members : <span>3</span></h4>
                    </div>
                    <div class="booking-center">
                        <p>
                            Time :
                            <span>9:30 - 10:30</span>
                        </p>
                        <p>
                            Date :
                            <span>3 February, 2023</span>
                        </p>
                    </div>
                </div>
            </div>
            <a href="" class="flex items-center bg-green custom-icon">
                <mat-icon class="custom-icon-style">edit </mat-icon>
                <span>Edit</span>
            </a>
            <a href="" class="flex items-center custom-del-icon">
                <mat-icon class="custom-icon-style">delete_forever</mat-icon>
                <span>Delete</span>
            </a>
        </div>
        <div class="w-3/4 mb-[2em] mx-[1em] relative appointment-container bg-">
            <div class="flex justify-between h-[100%]">
                <div class="md:flex">
                    <div class="booking-left">
                        <h2 class="text-left">Name</h2>
                        <h4>Total Members : <span>3</span></h4>
                    </div>
                    <div class="booking-center">
                        <p>
                            Time :
                            <span>9:30 - 10:30</span>
                        </p>
                        <p>
                            Date :
                            <span>3 February, 2023</span>
                        </p>
                    </div>
                </div>
            </div>
            <a href="" class="flex items-center bg-green custom-icon">
                <mat-icon class="custom-icon-style">edit </mat-icon>
                <span>Edit</span>
            </a>
            <a href="" class="flex items-center custom-del-icon">
                <mat-icon class="custom-icon-style">delete_forever</mat-icon>
                <span>Delete</span>
            </a>
        </div>
        <div class="w-3/4 mb-[2em] mx-[1em] relative appointment-container">
            <div class="flex justify-between h-[100%]">
                <div class="md:flex">
                    <div class="booking-left">
                        <h2 class="text-left">Name</h2>
                        <h4>Total Members : <span>3</span></h4>
                    </div>
                    <div class="booking-center">
                        <p>
                            Time :
                            <span>9:30 - 10:30</span>
                        </p>
                        <p>
                            Date :
                            <span>3 February, 2023</span>
                        </p>
                    </div>
                </div>
            </div>
            <a href="" class="flex items-center bg-green custom-icon">
                <mat-icon class="custom-icon-style">edit </mat-icon>
                <span>Delete</span>
            </a>
            <a href="" class="flex items-center custom-del-icon">
                <mat-icon class="custom-icon-style">delete_forever</mat-icon>
                <span>Delete</span>
            </a>
        </div>
    </div>
</section>